// react
import { useEffect } from "react";
// redux
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
// shell
import { selectIsStaticConfigurationLoaded, loadStaticConfiguration } from "../shellSlice";

interface IProps {
    children: React.ReactNode;
}

export default function ConfigurationController(props: IProps) {
    const { children } = props;
    const isStaticConfigurationLoaded = useAppSelector(selectIsStaticConfigurationLoaded);
    const dispatch = useAppDispatch();

    useEffect(() => {
        console.debug("Updating Static Configuration...");
        dispatch(loadStaticConfiguration());
    }, [dispatch]);

    // return - if the static configuration data is loaded
    if (!isStaticConfigurationLoaded) return <></>;
    return <>{children}</>;
}
